const isTest = window.location.href.indexOf('test') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('192.') > -1
export const CURRENT_CONFIG = {

  // license
  appId: '155590', // You need to go to the development website to apply.
  appKey: 'd38e465676b96a7a9ccb4d9e00e6129', // You need to go to the development website to apply.
  appLicense: 's4dscy8n5mTSXj1DmRp/VPOuf9psqgYJXwgNPLGOsXx+zxge4RscCx5Ew9wtiBLElHK8jHQRIEvNp9H+R5IApN1QZrQjrc2XJ/BjjFXsMd2zMXsAUFLxCSAAU/T1+l6igduHy/X21a6mNztVmb+lgGavtdt4TOqi8codvuVfYvM=', // You need to go to the development website to apply.

  // http
  // baseURL: 'https://airtruck.cloud-api.hyqfx.com/.', // This url must end with "/". Example: 'http://192.168.1.1:6789/'正式
  baseURL: isTest ? 'https://airtruck.cloud-api-test.hyqfx.com/.' : 'https://airtruck.cloud-api.hyqfx.com/.', // This url must end with "/". Example: 'http://192.168.1.1:6789/' 测试
  baseCloudWebURL: isTest ? 'https://airtruck.cloud-web-test.hyqfx.com/' : 'https://airtruck.cloud-web.hyqfx.com/',
  // baseURL: 'http://localhost:82/.', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  // websocketURL: 'wss://airtruck.cloud-api.hyqfx.com/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws' 正式
  websocketURL: isTest ? 'wss://airtruck.cloud-api-test.hyqfx.com/api/v1/ws' : 'wss://airtruck.cloud-api.hyqfx.com/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws' 测试
  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://47.106.114.155:11001/live/', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: '1b3509efd7068c148d71270d6117a4fb',

}
